import React, { useState } from 'react';
import { Card, Accordion, Form } from 'react-bootstrap';
import AgentCommissionPrice from './AgentCommissionPrice';
import AgentCommissionSplit from './AgentCommissionSplit';

const AgentCommission: React.FC = () => {
  const [entity, setEntity] = useState<string>('Individual');

  return (
    <Card.Body className="p-2">
      <Form.Group className="mb-2">
        <Form.Label style={{ fontSize: '13px', marginBottom: '4px' }}>Are you enquiring as a ?</Form.Label>
        <div>
          <Form.Check
            inline
            type="radio"
            label="Individual"
            name="entity"
            value="Individual"
            checked={entity === 'Individual'}
            onChange={(e) => setEntity(e.target.value)}
            style={{ fontSize: '13px' }}
          />
          <Form.Check
            inline
            type="radio"
            label="Business"
            name="entity"
            value="Business"
            checked={entity === 'Business'}
            onChange={(e) => setEntity(e.target.value)}
            style={{ fontSize: '13px' }}
          />
        </div>
      </Form.Group>

      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Card className="mb-1">
            <Card.Header className="p-0">
              <Accordion.Button className="text-start w-100 btn btn-secondary py-2" style={{ letterSpacing: '0.5px', fontSize: '13px' }}>
                Property Price Professional Fee
              </Accordion.Button>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <div>
                <AgentCommissionPrice entity={entity} />
              </div>
            </Accordion.Collapse>
          </Card>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Card className="mb-1">
            <Card.Header className="p-0">
              <Accordion.Button className="text-start w-100 btn btn-secondary py-2" style={{ letterSpacing: '0.5px', fontSize: '13px' }}>
                {entity === 'Individual' ? 'Property Practitioner' : 'Estate Agent'} Professional Fee
              </Accordion.Button>
            </Card.Header>
            <Accordion.Collapse eventKey="1">
              <div>
                <AgentCommissionSplit entity={entity} />
              </div>
            </Accordion.Collapse>
          </Card>
        </Accordion.Item>
      </Accordion>
    </Card.Body>
  );
};

export default AgentCommission;
